export default "__VITE_ASSET__BysXc5bK__"